import {
  returnsPolicy,
  defectivePolicy,
  refundPolicy,
} from "../policies/terms";
import React from "react";
import PolicyPage from "../policies/PolicyPage";
const sections = [
  {
    id: "section-1",
    title: "New gaming machines",
    paragraphs: [
      "New gaming machines carry a 60-day warranty from the date of delivery, excluding damage caused by abuse, improper servicing or events outside normal use. Contact us with your proof of purchase and machine serial number when requesting warranty service.",
    ],
  },
  {
    id: "section-2",
    title: "Used gaming machines",
    paragraphs: [
      "Used gaming machines carry a 30-day limited warranty from the date of delivery. During that period, return the defective part to us for assessment, repair or exchange, subject to the applicable warranty conditions.",
    ],
  },
  {
    id: "section-3",
    title: "Repairs",
    paragraphs: [
      "All repairs, including gaming-component repairs (logic boards, monitors, bill validators and printers) and road service, carry a 30-day repair warranty. The period runs from the date the repair is completed and is additional to rights that cannot lawfully be excluded.",
      "Repair coverage relates to the initial repair. An unrelated later fault is not automatically covered. Improper servicing or abuse may affect coverage for resulting damage.",
    ],
  },
  {
    id: "section-4",
    title: "Making a claim",
    paragraphs: [
      "Tell us that you are requesting warranty service when you bring the item for assessment. Provide your receipt or other proof of purchase, the machine or component serial number where available, the fault description and any previous repair reference. Contact us before shipping an item.",
      "For voluntary returns or chargeable service work, customers are responsible for agreed freight charges. For a valid statutory claim, we will meet any return-cost obligations required by law. Confirm the return arrangements with our team. Longer manufacturer warranties may have their own claim procedures; ask us for assistance. Work outside warranty is chargeable at the agreed service rate.",
    ],
  },
  {
    id: "section-5",
    title: "Returns and refunds",
    paragraphs: [
      returnsPolicy,
      defectivePolicy,
      refundPolicy,
      "Contact us for return authorisation and instructions before sending goods.",
    ],
  },
  {
    id: "section-6",
    title: "Collection and storage",
    paragraphs: [
      "Please collect your property within 30 days after notification that it is ready. Contact us promptly if you cannot collect it.",
      "After the 30-day collection period, a storage fee of JMD $250 per day may apply, charged for no more than 15 days, and only where disclosed and agreed in advance and after written notice. No fee applies to a delay caused by us. Contact us to discuss collection difficulties. Uncollected property does not automatically become our property; any further action must follow applicable law and appropriate notice.",
    ],
  },
  {
    id: "section-7",
    title: "Your statutory rights",
    paragraphs: [
      "These commercial warranty terms do not exclude rights or remedies that cannot lawfully be excluded under applicable Jamaican law. A manufacturer warranty does not by itself remove obligations owed by the seller. Contact us if you believe an item is defective or different from its description.",
    ],
  },
];
export default function Policy() {
  return (
    <PolicyPage
      title="Warranties & returns"
      intro="Coverage, service claims and the information to provide when a product needs attention."
      sections={sections}
    />
  );
}
